import React from "react";
import { Box } from "@mui/material";
import {
  settingsTabBarSx,
  settingsTabItemActiveSx,
  settingsTabItemSx,
} from "../../shared/styles";

function ChatWidgetSubTabs({ tabs, activeTab, onChange }) {
  return (
    <Box sx={{ ...settingsTabBarSx, mt: "24px" }}>
      {tabs.map((tab) => (
        <Box
          key={tab.key}
          component="button"
          type="button"
          onClick={() => onChange(tab.key)}
          style={{
            fontSize: "14px",
          }}
          sx={{
            ...settingsTabItemSx,
            ...(activeTab === tab.key ? settingsTabItemActiveSx : {}),
          }}
        >
          {tab.label}
        </Box>
      ))}
    </Box>
  );
}

export default ChatWidgetSubTabs;
